'use client';

import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { withDisplayName } from '../../lib/display-name';

export interface SListProps extends HTMLAttributes<HTMLDivElement> {
  /** 리스트 컨테이너 내부에 렌더링할 내용 */
  children?: ReactNode;
  /** 리스트 아이템 사이 gap 토큰 적용 여부 */
  useGap?: boolean;
  /** 리스트 컨테이너 padding 토큰 적용 여부 */
  usePadding?: boolean;
}

const SListImpl = forwardRef<HTMLDivElement, SListProps>(function SList(
  { className, children, useGap = false, usePadding = false, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        useGap && 'flex flex-col gap-(--cmp-list-group-gap)',
        usePadding && 'p-(--cmp-list-group-padding)',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export const SList = withDisplayName(SListImpl, 'SList');
